export default {
  title: 'Login information',
  username: 'Username',
  password: 'Password',
  securityQuestions: 'Security questions',
  securityQuestionsValue: '3 secret questions',
  buttonModify: 'Edit',
};
